export type CrmJobsTransitionStatusDto = {
    readonly fieldMappingsTransition?: boolean;
    readonly crmJobsTransition?: boolean;
};

export type CrmJobsTransitionDto = {
    readonly salesforce?: CrmJobsTransitionStatusDto;
    readonly hubspot?: CrmJobsTransitionStatusDto;
};

export const crmJobsTransitionProviderMap = {
    salesforce: "salesforce",
    hubspot: "hubspot",
} as const;

export type CrmJobsTransitionProvider =
    (typeof crmJobsTransitionProviderMap)[keyof typeof crmJobsTransitionProviderMap];

export const isCrmJobsTransitionProvider = (provider: string): provider is CrmJobsTransitionProvider =>
    provider === crmJobsTransitionProviderMap.salesforce || provider === crmJobsTransitionProviderMap.hubspot;
